/**
Project: Voice Panel (c)
Title: Azure APP Insight
Description: Component for App Insight Logs
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/

import React, { Fragment } from 'react';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from '../settings/azure-insights-config.js';
import { withRouter } from 'react-router-dom';


const AzureInsitghtsProvider = (props) => {
    const { children } = props;
    return (
        <Fragment>
            {children}
        </Fragment>
    )
}

export default withRouter(withAITracking(reactPlugin, AzureInsitghtsProvider));